import { useEffect } from "react";
import { Navigate } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { useAuth } from "@/contexts/AuthContext";
import { useRequireMfa } from "@/hooks/use-require-mfa";
import AutoScanPage from "./autoscan/AutoScanPage";

export default function AutoScanRoute() {
  const { user, loading } = useAuth();
  const { checking } = useRequireMfa();

  const { data: isAdmin, isLoading: isAdminLoading, refetch } = useQuery({
    queryKey: ["isAdmin", user?.id],
    queryFn: async () => {
      const { data } = await supabase
        .from("user_roles")
        .select("role")
        .eq("user_id", user!.id)
        .eq("role", "admin")
        .maybeSingle();
      return !!data;
    },
    enabled: !!user,
  });

  useEffect(() => {
    if (user) refetch();
  }, [user, refetch]);

  if (checking || loading || isAdminLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background text-primary">
        Loading...
      </div>
    );
  }

  if (!user || isAdmin === false) {
    return <Navigate to="/portal" replace />;
  }

  return <AutoScanPage />;
}

